import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { Button, Divider, Grid2, TextField, Typography } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { PAGE_LIST } from "../../pages";
import InnerLink from "../../components/InnerLink";
import { userRegister } from "../../store/userSlice/userRequests";
import { selectLoggedIn } from "../../store/userSlice/userSelectors";
import { userProfileValidation as validationSchema } from "../../validations/userProfile";

import classes from './index.module.scss';

const RegisterContainer = () => {
  const [success, setSuccess] = useState(false);
  const isLoggedIn = useSelector(selectLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(PAGE_LIST.CERTIFICATE)
    }
  }, [isLoggedIn])

  const registerFormik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      companyName: '',
      email: '',
      phone: '',
      username: '',
      password: '',
      confirmPassword: '',
    },
    onSubmit: () => {},
    validationSchema,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const onSubmit = async () => {
    const errorList = await registerFormik.validateForm();

    if (isEmpty(errorList)) {
      dispatch(userRegister(registerFormik.values))
        .then((action) => {
          const errorText = action?.payload?.message;

          if (errorText) {
            registerFormik.setErrors({
              username: errorText,
              email: true,
            })
          } else {
            setSuccess(true)
          }
        })
    }
  }

  if (success) {
    return (
      <Grid2
        container
        className={classes.registerContainer}
        direction="column"
        spacing={8}
      >
        <Grid2>
          <Typography variant='h1'>Registration was successful</Typography>
        </Grid2>
        <Grid2>
          <Typography variant='body1'>Check your inbox to confirm your email</Typography>
        </Grid2>
      </Grid2>
    )
  }

  return (
    <Grid2
      container
      className={classes.registerContainer}
    >
      <Grid2
        container
        direction='column'
        rowSpacing={2}
        className={classes.registerForm}
      >
        <Grid2>
          <Typography variant='h1' align='center'>Register Account</Typography>
        </Grid2>
        <Grid2
          container
          direcion='row'
          spacing={2}
          columnSpacing={2}
        >
          <Grid2 size={6}>
            <Typography variant='body1'>Username*</Typography>
            <TextField
              variant='outlined'
              name='username'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your username'
              value={registerFormik.values?.username}
              onChange={registerFormik.handleChange}
              error={Boolean(registerFormik?.errors?.username)}
              helperText={registerFormik?.errors?.username}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Email*</Typography>
            <TextField
              variant='outlined'
              name='email'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your email address'
              value={registerFormik.values?.email}
              onChange={registerFormik.handleChange}
              error={Boolean(registerFormik?.errors?.email)}
              helperText={registerFormik?.errors?.email}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Password*</Typography>
            <TextField
              variant='outlined'
              name='password'
              size='medium'
              fullWidth
              className={classes.input}
              type='password'
              value={registerFormik.values?.password}
              onChange={registerFormik.handleChange}
              error={Boolean(registerFormik?.errors?.password)}
              helperText={registerFormik?.errors?.password}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Confirm password*</Typography>
            <TextField
              variant='outlined'
              name='confirmPassword'
              size='medium'
              fullWidth
              className={classes.input}
              type='password'
              value={registerFormik.values?.confirmPassword}
              onChange={registerFormik.handleChange}
              error={Boolean(registerFormik?.errors?.confirmPassword)}
              helperText={registerFormik?.errors?.confirmPassword}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>First Name</Typography>
            <TextField
              variant='outlined'
              name='firstName'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your first name'
              value={registerFormik.values?.firstName}
              onChange={registerFormik.handleChange}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Last Name</Typography>
            <TextField
              variant='outlined'
              name='lastName'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your last name'
              value={registerFormik.values?.lastName}
              onChange={registerFormik.handleChange}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Phone</Typography>
            <TextField
              variant='outlined'
              name='phone'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your phone number'
              value={registerFormik.values?.phone}
              onChange={registerFormik.handleChange}
            />
          </Grid2>

          <Grid2 size={6}>
            <Typography variant='body1'>Company Name</Typography>
            <TextField
              variant='outlined'
              name='companyName'
              size='medium'
              fullWidth
              className={classes.input}
              placeholder='Your company name'
              value={registerFormik.values?.companyName}
              onChange={registerFormik.handleChange}
            />
          </Grid2>
        </Grid2>
        <Grid2>
          <Divider />
        </Grid2>
        <Grid2 container>
          <Grid2 size={6}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              className={classes.registerButton}
              onClick={onSubmit}
            >
              Create account
            </Button>
          </Grid2>
          <Grid2 size={6} container direction='row' className={classes.loginText}>
            <Grid2>
              <Typography variant='body1'>Already have an account?</Typography>
            </Grid2>
            <Grid2 container className={classes.loginLink}>
              <InnerLink href={PAGE_LIST.LOGIN} color='secondary'>Sign in</InnerLink><ArrowForwardOutlinedIcon
              className={classes.loginIcon} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  )
}

export default RegisterContainer;